import { useEffect, useState } from 'react';
import { WebsiteLanguage } from '../Models/Models';
import { WebsiteLanguageService } from '../Services/WebsiteLanguageService';

/** Languages enabled for the website; null while loading. */
export function useSiteLanguages(websiteId: number): WebsiteLanguage[] | null {
    const { getSiteLanguages } = WebsiteLanguageService();
    const [languages, setLanguages] = useState<WebsiteLanguage[] | null>(null);

    useEffect(() => {
        let alive = true;
        setLanguages(null);
        getSiteLanguages(websiteId).then(list => {
            if (alive) setLanguages(list ?? []);
        });
        return () => { alive = false; };
    }, [websiteId]);

    return languages;
}

/** The language a new translation set starts in: Slovak if enabled, else the first public, else the first enabled. */
export function pickDefaultLanguage(languages: WebsiteLanguage[]): string | undefined {
    return (
        languages.find(l => l.languageCode === 'sk')
        ?? languages.find(l => l.isPublic)
        ?? languages[0]
    )?.languageCode;
}
